import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export const RightArrow: React.FunctionComponent<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <path
                            d="M0 0H24V24H0z"
                            transform="translate(-80 -91) translate(16 60) matrix(-1 0 0 1 88 31)"
                        />
                        <g stroke="#585858" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                            <path
                                d="M14 7L0 7M7 14L0 7 7 0"
                                transform="translate(-80 -91) translate(16 60) matrix(-1 0 0 1 88 31) translate(5 5)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

export const LeftArrow: React.FunctionComponent<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <path d="M0 0H24V24H0z" transform="translate(-40 -91) translate(16 60) translate(24 31)" />
                        <g stroke="#585858" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                            <path
                                d="M14 7L0 7M7 14L0 7 7 0"
                                transform="translate(-40 -91) translate(16 60) translate(24 31) translate(5 5)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);
